import React from "react";

export default function PlaceholderLine() {
  return (
    <div style={{ marginTop: 16, paddingBottom: 16, borderTop: '1px solid var(--color-neutrals-40)', }}>
      {/* placeholder line */}
    </div>
  );
}
